export enum ConnectionState {
  IDLE = 'IDLE',
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  ERROR = 'ERROR'
}

export interface User {
  id: string;
  name: string;
}

export type MessageType = 'text' | 'image' | 'file';

export interface ChatMessage {
  id: string;
  senderId: string;
  senderName: string;
  text?: string;
  fileUrl?: string;
  fileName?: string;
  fileSize?: number;
  fileType?: string;
  timestamp: number;
  type: MessageType;
}

export interface FileTransferMeta {
  id: string;
  name: string;
  size: number;
  type: string;
  totalChunks: number;
}

export interface FileTransferProgress {
  id: string;
  fileName: string;
  progress: number; // 0 to 100
  direction: 'incoming' | 'outgoing';
}

export interface SignalingMessage {
  type: 'offer' | 'answer' | 'candidate' | 'handshake';
  payload?: any;
  sender?: string;
}
